import { convert } from 'encoding-japanese'
import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    text: null,
    busy: false,
  },
  mutations: {
    busy(state, busy) {
      state.busy = !!busy
    },
    set(state, text) {
      state.text = text
    },
  },
  getters: {
    blob: ({ text }) => {
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const uint8Array = new Uint8Array(convert(text, { to: 'UTF8', type: 'array' }))
      return new Blob([bom, uint8Array], { type: 'text/csv' })
    },
  },
  actions: {
    async get({ commit }, { query, target }) {
      commit('busy', true)

      const targetUrl = `/api/web/analysis/${target !== 'progress' ? 'reservation/' : ''}${target}/csv`

      const { status, message, data } = await POST(targetUrl, {
        ...query,
        unit: query.unit === 5 ? 4 : query.unit,
      })
      if (status === 200) {
        commit('set', data.csv)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
